const UNITS = [
  { threshold: 1, suffix: '' },
  { threshold: 1_000, suffix: '千' },
  { threshold: 10_000, suffix: '万' },
  { threshold: 100_000_000, suffix: '亿' },
  { threshold: 1_000_000_000_000, suffix: '万亿' },
] as const

const numberFormat = new Intl.NumberFormat('zh-CN', {
  maximumFractionDigits: 2,
  useGrouping: false,
})

/** Shorten a metric in its original unit, without changing the source value. */
export function formatMagnitude(value: string | number | null | undefined): string {
  if (value === null || value === undefined) return '--'
  if (typeof value === 'string' && !/^[+-]?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i.test(value.trim())) return '--'
  const numeric = Number(value)
  if (!Number.isFinite(numeric)) return '--'

  const magnitude = Math.abs(numeric)
  let unitIndex = UNITS.length - 1
  while (unitIndex > 0 && magnitude < UNITS[unitIndex].threshold) unitIndex -= 1

  let formatted = numberFormat.format(magnitude / UNITS[unitIndex].threshold)
  // A rounded value such as 10 千 should advance to 1 万.
  while (unitIndex < UNITS.length - 1 && Number(formatted) >= UNITS[unitIndex + 1].threshold / UNITS[unitIndex].threshold) {
    unitIndex += 1
    formatted = numberFormat.format(magnitude / UNITS[unitIndex].threshold)
  }
  const sign = numeric < 0 && Number(formatted) !== 0 ? '-' : ''
  return `${sign}${formatted}${UNITS[unitIndex].suffix}`
}
